import { Checkbox } from "antd";
import { bool, object } from "prop-types";
import { useIntl } from "react-intl";

import { DynamicFormItem } from "./DynamicFormItem";
import { useCheckEditableFormField } from "./hooks/useCheckEditableFormField";

export const DynamicCheckbox = ({
  formField,
  formField: {
    property,
    property: { name, label },
  },
  formDisabled,
}) => {
  const intl = useIntl();
  const { isDisabled } = useCheckEditableFormField(formField);

  return (
    <DynamicFormItem
      formFieldProperty={property}
      valuePropName="checked"
      hideLabel
    >
      <Checkbox
        disabled={formDisabled || isDisabled}
        data-test-id={`dynamic-checkbox-${name}`}
      >
        {intl.formatMessage({
          id: label.id,
          defaultMessage: label.fallback,
        })}
      </Checkbox>
    </DynamicFormItem>
  );
};

DynamicCheckbox.propTypes = {
  formField: object.isRequired,
  formDisabled: bool,
};
